// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__39zXS","content":"styles_content__NLRB4","checkbox":"styles_checkbox__3pcax","checkboxLabel":"styles_checkboxLabel__2vM8E"};